import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class SmsCampaignService {

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _httpClient: HttpClient
  ) { }

  // Get store list
  getStores(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/retailers';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get sms campaigns
  getSmsCampaigns(token: string, retailerId: string, storeId: string, page: any){
    const URL = environment.apiUrl + 'dashboard/smsCampaigns';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('retailer_id', retailerId)
      .set('store_id', storeId)
      .set('page', page);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Get internal sms campaign users
  getInternalSmsCampaignUsers(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/internalSmsCampaignUsers';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Create SMS campaign
  createSMSCampaign(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/createSMSCampaign';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Edit SMS campaign
  updateSMSCampaign(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/updateSMSCampaign';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Cancel SMS campaign
  cancelSMSCampaign(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/cancelSMSCampaign';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

}
